import { URL } from 'react-native-url-polyfill';

export const extractQueryParamaters = (url: string): {[key: string]: string} => {
  const parsedUrl = new URL(url);
  const searchParams = parsedUrl.searchParams.entries();
  const params = {};
  for (const param of searchParams) {
    params[param[0]] = param[1];
  }

  if (params.accessToken && params.idToken && params.providerId) {
    return {
      loginWithToken: {
        ...params,
      },
    };
  }
  if (parsedUrl.pathname === '/auth/login/garmin') {
    return {
      garminAuth: {
        oauthToken: params.oauth_token,
        oauthVerifier: params.oauth_verifier,
      },
    };
  }

  if (url.startsWith('fitillion://debug')) {
    return {
      devToolsToggling: params,
    };
  }

  return params;
};
